/**
 * Composable that provides step display number logic.
 * New UI flows have stepNumber set; old UI flows do not.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useStepDisplay() {
  /**
   * Returns the number to display for a step in dropdowns, tags, and titles.
   * If stepNumber is present (new UI), uses it; otherwise falls back to positional index(ix) + 1.
   */
  function getStepDisplayNumber(
    positionalIndex: number,
    stepNumber?: number
  ): number {
    if (stepNumber != null && stepNumber > 0) {
      return stepNumber;
    }
    return positionalIndex + 1;
  }

  return { getStepDisplayNumber };
}
